import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import { Box, Input } from "@chakra-ui/react"
import { Form } from "components"

const darkInput = {
    bg: '#16191d',
    borderColor: 'rgba(255,255,255,0.32)',
    color: 'rgba(255,255,255,0.92)',
    _placeholder: { color: 'rgba(255,255,255,0.28)' },
    _hover:  { borderColor: 'rgba(255,255,255,0.50)' },
    _focus:  { borderColor: '#f97316', boxShadow: '0 0 0 1px #f97316' },
    _disabled: { opacity: 0.45, cursor: 'not-allowed' },
}

// Aplica no country-selector (fora do Chakra Input) em dark mode
const phoneWrapperCss = {
    '& .PhoneInput': { width: '100%', gap: '8px' },
    '& .PhoneInputCountry': {
        display: 'flex',
        alignItems: 'center',
        padding: '0 10px',
        borderRadius: '6px',
        border: '1px solid transparent',
        flexShrink: 0,
        transition: 'border-color 0.15s',
    },
    '.dark & .PhoneInputCountry': {
        background: '#16191d',
        borderColor: 'rgba(255,255,255,0.32)',
    },
    '.dark & .PhoneInputCountry:hover': {
        borderColor: 'rgba(255,255,255,0.50)',
    },
}

export default function Mobile({ onChange = () => {}, value = '', ...props }) {
    return (
        <Form.Field {...props}>
            <Box w="100%" css={phoneWrapperCss}>
                <PhoneInput
                    international
                    defaultCountry="BR"
                    countrySelectProps={{ unicodeFlags: true }}
                    placeholder="Ex.: +55 62 9 9999 9999"
                    inputComponent={Input}
                    value={value ?? ''}
                    onChange={onChange}
                    style={{ display: 'flex', width: '100%' }}
                    numberInputProps={{ inputMode: 'tel', name: props.name, _dark: darkInput }}
                />
            </Box>
        </Form.Field>
    )
}
